import React from 'react';
import memoize from 'memoize-one';
import moment from 'moment';
import RowActions from './RowActions';
// import { DatatableEmployeeName } from '../../../components';

const columns = memoize(clickHandler => [
  {
    name: 'RUT Y NOMBRE',
    selector: 'full_name',
    cell: item => {
      return (
        <>
          <div className="d-flex flex-column" role="presentation">
            <span className="text-muted" data-tag="allowRowEvents">
              {item?.rut}
            </span>
            <span data-tag="allowRowEvents">{item?.fullName}</span>
            {item.startDateContract && (
              <span className="text-muted" data-tag="allowRowEvents">
                ({item.startDateContract})
              </span>
            )}
          </div>
        </>
      );
    },
    sortable: true,
    grow: '2'
  },
  {
    name: 'CENTRO DE COSTO',
    selector: 'employee_cost_center',
    cell: item => item.payrollInfo?.costCenterName,
    sortable: true,
    grow: '2'
  },
  {
    name: 'ÁREA',
    selector: 'job_management',
    cell: item => item.payrollInfo?.jobManagementName,
    sortable: true,
    grow: '2'
  },
  {
    name: 'MES',
    selector: 'month',
    cell: item => item.payrollProcess?.month,
    sortable: true,
    grow: '1'
  },
  {
    name: 'AÑO',
    selector: 'year',
    cell: item => item.payrollProcess?.year,
    sortable: true,
    grow: '1'
  },
  {
    name: 'ESTADO',
    selector: 'file_status',
    cell: item => item.translateFileStatus,
    sortable: true,
    grow: '1'
  },
  {
    name: 'FECHA DE ESTADO',
    selector: 'updated_at',
    cell: item => moment(item.updatedAt).format('DD/MM/YYYY HH:mm'),
    sortable: true,
    grow: '2',
    center: true,
    minWidth: '123px'
  },
  {
    name: 'ACCIONES',
    cell: item => (
      <>
        <RowActions handleClick={clickHandler} item={item} />
      </>
    ),
    grow: '2',
    ignoreRowClick: true,
    allowOverflow: false,
    button: true,
    center: true,
    minWidth: '150px'
  }
]);

export default columns;
